import FiltersItem from "./FiltersItem";
import MoreFilters from "./MoreFilters";
import { applyUrlFiltersFunction } from "../../../../hooks/useUrlFilter";
import { IFilters, IFilterSchema } from "../../../../utils/types";

import { Box, Button, Typography, Stack } from "@mui/material";
import { useUrl } from "../../../../hooks/urlEncoding";

interface FiltersContainerProps {
  filters: IFilters;
  filtersSchema: IFilterSchema[];
  onApplyFilters: applyUrlFiltersFunction;
  onResetFilters?: applyUrlFiltersFunction;
}

export interface handleApplyFilterItemFunction {
  (column: string, operator: string, value: any): void;
}

export interface handleResetFilterItemFunction {
  (column: string): void;
}

const FiltersContainer: React.FC<FiltersContainerProps> = ({
  filters,
  filtersSchema,
  onApplyFilters,
}) => {
  const {  setParamWithSearchParams } = useUrl();
  const handleResetFilterItem: handleResetFilterItemFunction = (column) => {
    delete filters[column];
    onApplyFilters({ ...filters });
  };
  const handleApplyFilterItem: handleApplyFilterItemFunction = (
    column,
    operator,
    value
  ) => {
    filters[column] = { column, operator, value };
    onApplyFilters({ ...filters });
  };

  const filtersWithValue: IFilterSchema[] = [];
  const filtersWithoutValue: IFilterSchema[] = [];

  filtersSchema.forEach((filter) => {
    if (filter.props.value) {
      filtersWithValue.push(filter);
    } else {
      filtersWithoutValue.push(filter);
    }
  });

  const visibleFilters = [
    ...filtersWithValue,
    ...filtersWithoutValue.slice(0, Math.max(3 - filtersWithValue.length, 0)),
  ];

  const moreFilters = [
    ...filtersWithoutValue.slice(Math.max(3 - filtersWithValue.length, 0)),
  ];
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      justifyContent="space-between"
      gap={2}
    >
      <Box
        sx={{
          display: "flex",
          overflowX: "auto",
          gap: 1,
          scrollbarWidth: "none", // Firefox
          "&::-webkit-scrollbar": { display: "none" }, // Chrome, Safari
          width: { xs: "100%", md: "auto" },
          alignItems: "center",
          paddingLeft: "5px",
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight={500}
          color="text.primary"
          sx={{ flexShrink: 0 }}
        >
          فیلتر
        </Typography>

        {visibleFilters.map((filter, index) => (
          <FiltersItem
            key={index}
            filter={filter}
            onReset={handleResetFilterItem}
            onApply={handleApplyFilterItem}
          />
        ))}

        {moreFilters.length > 0 && (
          <MoreFilters
            moreFilters={moreFilters}
            onApply={handleApplyFilterItem}
          />
        )}
      </Box>

      {filtersWithValue.length > 0 && (
        <Button
          variant="text"
          onClick={() => onApplyFilters({})}
          sx={{
            color: "error.main",
            fontWeight: "normal",
            whiteSpace: "nowrap",
            textTransform: "none",
            alignSelf: { xs: "flex-start", md: "center" },
          }}
        >
          حذف همه فیلترها
        </Button>
      )}
    </Stack>
  );
};

export default FiltersContainer;
